import { render, staticRenderFns } from "./__store_camera_failure_msg.vue?vue&type=template&id=0ccabd08&scoped=true&"
import script from "./__store_camera_failure_msg.vue?vue&type=script&lang=js&"
export * from "./__store_camera_failure_msg.vue?vue&type=script&lang=js&"
import style0 from "./__store_camera_failure_msg.vue?vue&type=style&index=0&id=0ccabd08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccabd08",
  null
  
)

export default component.exports